"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchJobsRequest = void 0;
/**
 * Search Jobs Request
 * @doc SearchJobsRequest
 */
var SearchJobsRequest = /** @class */ (function () {
    function SearchJobsRequest(_a) {
        var _b = _a === void 0 ? {} : _a, nextPageToken = _b.nextPageToken, pageSize = _b.pageSize, orderBy = _b.orderBy, orderDirection = _b.orderDirection, issuer = _b.issuer, type = _b.type, status = _b.status, groupId = _b.groupId, fileId = _b.fileId, path = _b.path;
        this.nextPageToken = null;
        this.pageSize = null;
        this.orderBy = null;
        this.orderDirection = null;
        this.issuer = null;
        this.type = null;
        this.status = null;
        this.groupId = null;
        this.fileId = null;
        this.path = null;
        this.nextPageToken = nextPageToken || null;
        this.pageSize = pageSize || null;
        this.orderBy = orderBy || null;
        this.orderDirection = orderDirection || null;
        this.issuer = issuer || null;
        this.type = type || null;
        this.status = status || null;
        this.groupId = groupId || null;
        this.fileId = fileId || null;
        this.path = path || null;
    }
    return SearchJobsRequest;
}());
exports.SearchJobsRequest = SearchJobsRequest;
//# sourceMappingURL=search-jobs-request.js.map